
import React, { useEffect, useState, useRef } from 'react';
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
  TableInstance,
} from 'react-table';
import { Navigate, useNavigate } from 'react-router-dom';
import SelectField from 'components/fields/SelectField';
// Chakra imports
import {
  Flex,
  Text,
  Icon,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Box,
  Button,
  SimpleGrid,
  Tooltip,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  useDisclosure,
  useToast,
  Spinner,
} from '@chakra-ui/react';
import { HashLoader } from 'react-spinners';
import Card from 'components/card/Card';
import { getCompanyList, getSelectCreator } from 'utils/creator/creator';
import { getPlanName } from 'utils/plan/plan';
import {
  getAllLearners,
  // getLearnerFilter,
  getlearnerSpecifics,
} from 'utils/activitycontrols/activities';
import { getGameList } from 'utils/game/gameService';
import { getcohortslist } from 'utils/cohorts/cohorts';
import { formToJSON } from 'axios';
import { SearchIcon, CheckIcon } from '@chakra-ui/icons';
import InputField from 'components/fields/InputField';
import {
  IconButton,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
} from '@chakra-ui/react';
import { set } from 'lodash';

interface LearnerActivityData {
  sNo: number;
  lenUserName: string;
  lenCompanyId: any;
  lenMail: string;
  ctId: any;
  cpId: any;
  ctName: string;
  cpCompanyName: string;
  galGameId: any;
  gameTitle: string;
  originalScore: any;
  finalScore: any;
  Improvement: any;
  createdDate: any;
  cohortName: string;
  started: any;
  completed: any;
  progress: any;
  Timespend: any;
  Lastactive: any;
  QuestReplay: any;
  cohortId: any;
}
type RowObj = {
  sNo: number;
  lenUserName: string;
  lenCompanyId: any;
  lenMail: string;
  ctId: any;
  cpId: any;
  ctName: string;
  cpCompanyName: string;
  galGameId: any;
  gameTitle: string;
  originalScore: any;
  finalScore: any;
  Improvement: any;
  createdDate: any;
  cohortName: string;
  started: any;
  completed: any;
  progress: any;
  Timespend: any;
  Lastactive: any;
  QuestReplay: any;
  cohortId: any;
  [key: string]: any;
};

interface OptionType {
  value: string;
  label: string;
}
interface ColumnObj {
  Header: number | string;
  accessor: any;
}
interface planType {
  plPlan: string;
  plId: string;
}
interface LearnerActivityData {
  data: any;
}

type DataCol = TableInstance<RowObj>;

const Specific = ({}) => {
  const [localPageIndex, setLocalPageIndex] = useState(0);
  const [localPageSize, setLocalPageSize] = useState(10);
  const [isHovering, setIsHovering] = useState(false);
  const tableRef = useRef<HTMLDivElement | null>(null);
  const [data, setData] = useState([]);

  const [apiData, setApiData] = useState([]);
  const [apiDatacol, setApiDatacol] = useState([]);
  const [gameNames, setGames] = useState([]);
  const [cohort, setcohort] = useState([]);
  const [companyNames, setCompany] = useState([]);
  const storage = JSON.parse(localStorage.getItem('user'));

  //new state by kaviya for pagenation
  const [pageIndexState, setPageIndexState] = useState(0);
const [totalPages, setTotalPages] = useState(0);
const isFetchingRef = useRef(false);

  let storageCreatorId = '';
  const UserRole = storage.data.role;
  if (storage.data.role === 'Creator') {
    storageCreatorId = storage.data.id;
  }
  let storagelenNameId = '';
  const UserRolee = storage.data.role;
  if (storage.data.role === 'Creator') {
    storagelenNameId = storage.data.id;
  }
  const [lastPage, setLastPage] = useState<any>();
  const [AllLearners, setAllLearners] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);

  const [creatorOptions, setCreatorOptions] = useState([]);

  const [selected, setSelected] = useState({
    companyId: '',
    creatorId: '',
    lenUserName: '',
    galGameId: '',
    cohortId: '',
    // date: '',
     fromDate: '',    // ← add
  toDate: '' ,
   search: '',   // ← add
  });
  const [loadingdata, setLoadingdata] = useState(false);

  const [filteredCreators, setFilteredCreators] = useState([]);
  const [filteredGameOptions, setFilteredGameOptions] = useState([]);
  const [creators, setCreators] = useState([]);
  const [GameOptions, setGameOptions] = useState([]);
  const [cohortOption, setCohortOption] = useState([]);
  const [cohorts, setCohorts] = useState([]);

  const navigate = useNavigate();
  const searchIconColor = useColorModeValue('gray.700', 'white');
  let menuBg = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const toast = useToast();
  interface OptionTypecon {
    value: string;
    label: string;
    CompanyId: string;
    lenUserName: string;
    galGameId: string;
    cohortId: string;
  }
  const handleNavigate = () => {
    navigate('creation');
  };
  const galGameId = apiData.map((data: any) => data.galGameId);

  interface GameData {
    gameTitle: string;
    galGameId: any;
  }
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const gameTitle = apiData.map((data: any) => data.gameTitle);

  const [selectedGame, setSelectedGame] = useState<string>('');

  const [selectedButton, setSelectedButton] = useState(1);

  const [randomColumns, setColumns] = useState<ColumnObj[]>([]);
  interface GameOption {
    value: string;
    label: string;
  }

  const gameOptions: GameOption[] = apiData.map((game: GameData) => ({
    value: game.galGameId,
    label: game.gameTitle,
  }));
  const cohortId = apiData.map((data: any) => data.cohortId);

  interface CohortsData {
    cohortName: string;
    cohortId: any;
  }

  const cohortName = apiData.map((data: any) => data.cohortName);

  const [selectedCohorts, setSelectedCohorts] = useState<string>('');

  interface CohortOption {
    value: string;
    label: string;
  }



  const [searchText, setSearchText] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');


  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchText.trim());
      setPageIndexState(0);
    }, 500);
  
    return () => clearTimeout(timer);
  }, [searchText]);
const handleClick = React.useCallback(async () => {
  if (isFetchingRef.current) return;
  isFetchingRef.current = true;
  setLoadingdata(true);

  try {
    if (selected.galGameId) {
      const payload = JSON.stringify({
        ...selected,
        fromDate: selected.fromDate,
        toDate: selected.toDate,
        page: pageIndexState + 1,
         search: debouncedSearch|| "",
        limit: localPageSize,
      });

      console.log('Calling API with page:', pageIndexState + 1); // ← verify

      const result = await getlearnerSpecifics(payload);

      if (result?.status !== 'Success') {
        setData([]);
        setApiDatacol([]);
        setApiData([]);
        return;
      }

      console.log('totalPages from API:', result.totalPages); // ← verify
      setTotalPages(result.totalPages);
      setData(result?.data);
      setApiDatacol(result?.data);
      setApiData(result?.data);
    } else {
      setData([]);
      setApiDatacol([]);
      setApiData([]);
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    setLoadingdata(false);
    setTimeout(() => { isFetchingRef.current = false; }, 300);
  }
}, [selected, pageIndexState, localPageSize,selectedButton,debouncedSearch]); // ← dependencies here


  // useEffect(() => {
  //   handleClick();
  // }, [selected]);

  useEffect(() => {
  handleClick();
}, [selected, pageIndexState, localPageSize,debouncedSearch]);

  const cohortOptions: CohortOption[] = apiData.map((cohort: CohortsData) => ({
    value: cohort.cohortId,
    label: cohort.cohortName,
  }));

  // const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setSelected({
  //     ...selected,
  //     date: event.target.value,
  //   });
  // };
 
  
  
  
  const handleSpecfic = () => {
    window.open(
      `/specific`, // Replace with your desired URL or route /gameAnswer/:id
    );
  };

  const [isFeedbackView, setIsFeedbackView] = useState(false);
  const toColumnLetter = (num: number) => {
    let letter = '';
    while (num >= 0) {
      letter = String.fromCharCode((num % 26) + 65) + letter; // 65 is the char code for 'A'
      num = Math.floor(num / 26) - 1; // Adjust for zero-based index
    }
    return letter;
  };

  useEffect(() => {
    if (apiDatacol.length != 0) {
      const feedback: ColumnObj[] = [
        { Header: 'Content', accessor: 'FeedContent' },
        { Header: 'Relevance', accessor: 'FeedRelevance' },
        { Header: 'Behaviour', accessor: 'FeedBehaviour' },
        { Header: 'Recommendation', accessor: 'FeedRecommendation' },
        { Header: 'Gamification', accessor: 'FeedGamification' },
        { Header: 'Others', accessor: 'Others' },
      ];

      const forAdmin: ColumnObj[] = [
        { Header: 'companyName', accessor: 'cpCompanyName' },
        { Header: 'CreatorName', accessor: 'ctName' },
      ];

      const forCreator: ColumnObj[] = [
        { Header: 'sNo', accessor: 'sNo' },
        { Header: 'learnerName', accessor: 'lenUserName' },
        { Header: 'learnerMail', accessor: 'lenMail' },
        { Header: 'GameTitle', accessor: 'gameTitle' },
        { Header: 'AssignedDate', accessor: 'createdDate' },
        { Header: 'CohortName', accessor: 'cohortName' },
      ];

      if (UserRole !== 'Creator') {
        const insertIndex =
          forCreator.findIndex((col) => col.Header === 'learnerMail') + 1;

        forCreator.splice(insertIndex, 0, ...forAdmin);
      }

      if (selectedButton === 0) {
        /**********************skill tag**************** */

        const Skills = apiDatacol[0]?.Skills;
        if (Skills) {
          const keysArray = Skills.map((obj: any) => Object.keys(obj)[0]);

          let s = 1;

          const skilltag: ColumnObj[] = keysArray
            .map((key: any, index: number) => {
              const letter = toColumnLetter(index); // Get the corresponding letter for the index

              return [
                {
                  Header: `Original Score`, // Set the Header to the key name
                  accessor: `original_score${letter}`, // Set the accessor to the dynamic key
                },
                {
                  Header: `Final Score`,
                  accessor: `final_score${letter}`,
                },
                {
                  Header: `Improvement`,
                  accessor: `improvement${letter}`,
                },
              ];
            })
            .flat(); // Flatten the array of arrays into a single array

          const insertIndex0 =
            forCreator?.findIndex((col) => col.Header === 'CohortName') + 1;

          forCreator.splice(insertIndex0, 0, ...skilltag);
        }
      }
      if (selectedButton === 1) {
        /**********************approches tag**************** */
        const approcahes = apiDatacol[0]?.Approaches;
        const keysArray = approcahes.map((obj: any) => Object.keys(obj)[0]);

        // const approchestitle = approcahes.map((obj: any, index: any) => {
        //   const firstKey = Object.keys(obj)[1]; // Get the first key
        //   const letter = toColumnLetter(index);
        //   return {
        //     Header: obj[firstKey], // Set Header to the value of the first key
        //     accessor: `TitleAnswered${letter}`, // Set accessor to the first key
        //   };
        // });
        const approchestitle = approcahes.map((obj: any, index: any) => {
  const letter = toColumnLetter(index);
  return {
    Header: obj.Title ?? `Interaction-${index + 1}`,  // ← use Title field directly
    accessor: `TitleAnswered${letter}`,
  };
});

        const insertIndex1 =
          forCreator.findIndex((col) => col.Header === 'CohortName') + 1;

        forCreator.splice(insertIndex1, 0, ...approchestitle);
      }

      if (selectedButton === 2) {
        const reflection = apiDatacol[0]?.Reflection;

        const keysArray = reflection.map((obj: any) => Object.keys(obj)[0]);

        const approchestitle = reflection.map((obj: any, index: number) => {
          const letter = toColumnLetter(index); // Get the corresponding letter for the index
          const firstKey = Object.keys(obj)[1]; // Get the first key
          const secondKey = Object.keys(obj)[0]; // Get the first key
          return {
            Header: obj[firstKey], // Set Header to the value of the first key
            accessor: `answer${letter}`, // Set accessor to the first key
          };
        });
        const insertIndex1 =
          forCreator.findIndex((col) => col.Header === 'CohortName') + 1;

        forCreator.splice(insertIndex1, 0, ...approchestitle);
      }

      if (selectedButton === 3) {
        const insertIndex2 =
          forCreator.findIndex((col) => col.Header === 'CohortName') + 1;

        forCreator.splice(insertIndex2, 0, ...feedback);
      }
      //new by kaviya
       if (selectedButton === 4) {
        const refAnalytics = apiDatacol[0]?.ReflectionAnalytics;
        const refColumns = refAnalytics?.columns ?? [];

      
        const reflectionAnalyticsCols: ColumnObj[] = [];
        refColumns.forEach((group: any) => {
          if (group.children && group.children.length > 0) {
            group.children.forEach((child: any) => {
              reflectionAnalyticsCols.push({
                Header: child.header,    // "Reflection question 1 for quest 1"
                accessor: child.accessor, // "Q1_R1"
              });
            });
          }
        });

        const insertIndex4 =
          forCreator.findIndex((col) => col.Header === 'CohortName') + 1;
        forCreator.splice(insertIndex4, 0, ...reflectionAnalyticsCols);
      }

      setColumns(forCreator);
    }
  }, [selectedButton, apiDatacol]);

  const columns = React.useMemo(() => {
    return [...randomColumns];
  }, [randomColumns]);

  const handleButtonClick = (index: any) => {
    setSelectedButton(index);
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
    gotoPage,
    setPageSize,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
  }: DataCol = useTable<RowObj>(
    {
      columns,
      data: data,
      // initialState: { pageIndex: localPageIndex, pageSize: localPageSize },
      manualPagination: true,
pageCount: totalPages,
state: { pageIndex: pageIndexState },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );
  const mappedPlanOptions = Array.isArray(creators)
    ? creators.map((creators) => ({
        value: creators.plId,
        label: creators.plPlan,
      }))
    : [];
  useEffect(() => {
    toast({
      // title: `Please select Atleast one game to see specifics`,
      title: `Please select atleast one game to see specifics`,
      position: 'top',
      status: 'error',
      isClosable: true,
    });
    const lastPage = Math.floor(data.length / pageSize);
    setLastPage(Math.floor(data.length / pageSize));
  }, []);

  // const totalPages = Math.ceil(data.length / pageSize);

  // const handleGoPage = (pageNumber: number) => {
  //   if (pageNumber >= 0 && pageNumber < totalPages) {
  //     setLocalPageIndex(pageNumber);
  //     gotoPage(pageNumber);
  //   }
  // };

  // const getPageNumbers = () => {
  //   const pageCount = 3;
  //   const currentPage = pageIndex + 1;
  //   const pages = [];

  //   if (totalPages <= pageCount) {
  //     // Display all pages if total pages are less than or equal to the page count
  //     for (let i = 0; i < totalPages; i++) {
  //       pages.push(i + 1);
  //     }
  //   } else {
  //     const start = Math.max(1, currentPage - Math.floor(pageCount / 2));
  //     const end = Math.min(totalPages, start + pageCount - 1);

  //     if (start > 1) {
  //       pages.push(1, '...');
  //     }

  //     for (let i = start; i <= end; i++) {
  //       pages.push(i);
  //     }

  //     if (end < totalPages) {
  //       pages.push('...', totalPages);
  //     }
  //   }

  //   return pages;
  // };

const handleGoPage = (pageNumber: number) => {
  if (pageNumber >= 0 && pageNumber < totalPages) {
    setPageIndexState(pageNumber);
  }
};

const getPageNumbers = () => {
  const pages = [];
  const visiblePages = 5;
  const currentPage = pageIndexState + 1;

  let start = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  let end = Math.min(totalPages, start + visiblePages - 1);

  if (end === totalPages) {
    start = Math.max(1, totalPages - visiblePages + 1);
  }

  if (start > 1) {
    pages.push(1);
    if (start > 2) pages.push('...');
  }

  for (let i = start; i <= end; i++) pages.push(i);

  if (end < totalPages) {
    if (end < totalPages - 1) pages.push('...');
    pages.push(totalPages);
  }

  return pages;
};

  useEffect(() => {
    const fetchData = async () => {
      setLoadingdata(true);
      try {
        // const AllLearner = await getLearnerFilter();
        // setAllLearners(AllLearner.data);
        // if (AllLearner?.status !== 'Success')
        //   return console.log('AllLearner Error:', AllLearner?.message);

        // // Check if user role is 'AllLearner'
        // if (UserRole === 'AllLearner') {
        //   const selectAllLearnerData: OptionTypecon[] = AllLearner?.data || [];
        //   const foundItem = selectAllLearnerData.find(
        //     (item) => item.value === storagelenNameId,
        //   );
        //   setSelected({ ...selected, lenUserName: foundItem?.lenUserName });
        // }

        const company = await getCompanyList();
        setCompanyOptions(company?.data);
        setCompany(company?.data);
        if (company?.status !== 'Success')
          return console.log('getCountries Error:', company?.message);

        const game = await getGameList();
console.log(game,'gamelist')
        if (game?.status !== 'Success')
          return console.log('getCountries Error :', game?.message);

        setGameOptions(game?.data);
        setGames(game?.data);

        try {
          const cohort = await getcohortslist();
          console.log(cohort,'cohortlist')
          if (cohort?.status === 'Success') {
            setCohortOption(cohort.data);
            setcohort(cohort.data);
          } else {
            console.log('getCohortsList Error:', cohort?.message); // Logs error, but doesn’t break other fetches
          }
        } catch (error) {
          console.log('Error fetching cohorts:', error);
        }

        const creator = await getSelectCreator(); // Replace with your actual function to get plan names

        if (creator?.status !== 'Success')
          return console.log('getPlanNames Error:', creator?.message);
        setCreatorOptions(creator.data);
        setCreators(creator.data);

        // Set default values based on user role
        if (UserRole === 'Creator') {
          const selectCreatorData: OptionTypecon[] = creator?.data || [];
          const foundCompany = selectCreatorData.find(
            (item) => item.value === storageCreatorId,
          );

          // Populate the selected state with company and creator details
          if (foundCompany) {
            setSelected({
              ...selected,
              companyId: foundCompany.CompanyId,
              creatorId: foundCompany.value,
            });
          }
        }
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      } finally {
        setLoadingdata(false);
      }
    };

    fetchData();
  }, []);
  const fixedColumnsCount = UserRole === 'Admin' ? 8 : 6;
console.log(apiDatacol,'apiDatacol')
  useEffect(() => {
    setData(
      apiDatacol.length === 0
        ? []
        : apiDatacol.map((item: any, inx: number) => ({
            ...item,
            inx,
            // sNo: inx + 1,
            sNo: item.sNo,
            lenUserName: item.lenUserName,
            lenMail: item.lenMail,
            cpCompanyName: item.cpCompanyName,
            ctName: item.ctName,
            gameTitle: item.gameTitle,
            createdDate: item.createdDate,
            cohortName: item.cohortName,
            // ...(selectedButton === 0 &&
            //   item.Skills.reduce((acc: any, items: any, inx: number) => {
            //     let snn = inx++;
            //     acc[`original_score${toColumnLetter(snn)}`] =
            //       items.originalScore;
            //     acc[`final_score${toColumnLetter(snn)}`] = items.finalScores;
            //     acc[`improvement${toColumnLetter(snn)}`] = items.improvement;
            //     return acc;
            //   }, {})),
            ...(selectedButton === 1 &&
              Array.isArray(item.Approaches) &&
              item.Approaches.reduce((acc: any, items: any, inx: number) => {
                let snn = inx;
                const isCorrect = items.correctAnswer === 'true';

                acc[`TitleAnswered${toColumnLetter(snn)}`] =
                  items.correctAnswer ? (
                    <>
                      {isCorrect && (
                        <CheckIcon
                          color={'green'}
                          w="15px"
                          h="15px"
                          marginTop="20px"
                        />
                      )}
                      {items.TitleAnswered}
                    </>
                  ) : (
                    <>{items.TitleAnswered}</>
                  );

                return acc;
              }, {})),
            ...(selectedButton === 2 &&
              item.Reflection.reduce((acc: any, items: any, inx: number) => {
                let snn = inx++;

                acc[`answer${toColumnLetter(snn)}`] = items.answers;
                return acc;
              }, {})),

            // ...( selectedButton === 3 && item.Feedback
            ...(selectedButton === 3 && Array.isArray(item.Feedback)
              ? item.Feedback.reduce((acc: any, items: any, inx: number) => {
                  let snn = inx + 1; // Increment inx for display or other use if needed

                  acc[`FeedContent${snn}`] = items.FeedContent;
                  acc[`FeedRelevance${snn}`] = items.FeedRelevance;
                  acc[`FeedBehaviour${snn}`] = items.FeedBehaviour;
                  acc[`FeedRecommendation${snn}`] = items.FeedRecommendation;
                  acc[`FeedGamification${snn}`] = items.FeedGamification;
                  acc[`Others${snn}`] = items.Others;

                  return acc;
                }, {})
              : {}),
              //new by kaviya
              ...(selectedButton === 4
              ? item?.ReflectionAnalytics?.rows?.[0] ?? {}
              : {}),
          })),
    );
  }, [selectedButton, apiDatacol]);

  useEffect(() => {
    // Fetch data as before...

    if (UserRole === 'Admin' || UserRole === 'Creator') {
      const initialFiltered = UserRole === 'Creator' ? creators : [];
      setFilteredCreators(initialFiltered);
    }
  }, [UserRole, creators]);

  useEffect(() => {
    // Check if GameOptions contains data
    if (!GameOptions || GameOptions.length === 0) {
      console.log('No games to filter');
      return;
    }

    if (selected.creatorId) {
      const filteredGames = GameOptions.filter(
        (game) => game.key === selected.creatorId,
      );
      setFilteredGameOptions(filteredGames);
    } else {
      setFilteredGameOptions(GameOptions);
    }
  }, [selected.creatorId, GameOptions]);

  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      if (isHovering && tableRef.current) {
        // Prevent vertical scroll on body
        if (e.deltaY !== 0) {
          e.preventDefault();
          // Scroll horizontally based on vertical scroll movement
          tableRef.current.scrollLeft += e.deltaY;
        }
      }
    };

    // Add event listener for scroll on window
    if (isHovering) {
      window.addEventListener('wheel', handleWheel, { passive: false });
    } else {
      window.removeEventListener('wheel', handleWheel);
    }

    return () => {
      // Cleanup the event listener
      window.removeEventListener('wheel', handleWheel);
    };
  }, [isHovering]);

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  const handleGameChange = (selectedOption: OptionTypecon | null) => {
    setSelected({
      ...selected,
      galGameId: selectedOption.value,
    });
  };

  const handleCohortsChange = (selectedOption: OptionTypecon | null) => {
    setSelected({
      ...selected,
      cohortId: selectedOption?.value,
      companyId: selected.companyId,
    });
  };

  const handleCompanyChange = (selectedOption: OptionTypecon | null) => {
    setSelected({
      ...selected,
      companyId: selectedOption.value,
    });
  };
  const handleCreatorIdChange = (selectedOption: OptionTypecon | null) => {
    if (selectedOption) {
      setSelected({
        ...selected,
        creatorId: selectedOption.value,
      });
    } else {
      setSelected({
        ...selected,
        creatorId: '',
        galGameId: '',
      });
    }
  };
  const handleLeanerIdChange = (selectedOption: OptionType | null) => {
    setSelected({
      ...selected,

      lenUserName: selectedOption.value,
    });
  };

  const handleCohortChange = (selectedOption: OptionType | null) => {
    setSelected({ ...selected, cohortId: selectedOption?.value });
  };

  console.log('pagettyy', page);

  return (
    <>
      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <h1
        style={{
          color: '#1b254b',
          fontSize: '34px',
          fontWeight: '500',
          margin: '20px',
        }}
      >
        Game Specifics
      </h1>

      <Card mt={'20px'} width={'100%'}>
        <SimpleGrid
          columns={{ base: 1, md: 3, lg: 3 }}
          // ml="30px"
          spacing={6}
        >
          {UserRole === 'Admin' || UserRole === 'Creator' ? (
            <>
              <SelectField
                mb="0px"
                id="ctCompanyId"
                name="companyId"
                label="Company Name"
                options={companyOptions}
                onChange={handleCompanyChange}
                value={
                  companyOptions.find(
                    (option) => option.value === selected.companyId,
                  ) || null
                }
                isDisabled={storage.data.role === 'Creator'}
                isClearable={true}
              />
              <SelectField
                mb="0px"
                id="ctCompanyId"
                name="planId"
                label="Creator Name"
                // options={creatorOptions}
                options={
                  selected.companyId
                    ? creatorOptions.filter(
                        (option: any) =>
                          option.CompanyId === selected.companyId,
                      )
                    : creatorOptions
                }
                onChange={handleCreatorIdChange}
                value={
                  creatorOptions.find(
                    (option) => option.value === selected.creatorId,
                  ) || null
                }
                // isDisabled={storage.data.role === 'Creator'}
                isClearable={true}
              />
              <div>
                <SelectField
                  mb="0px"
                  id="gameId"
                  name="gameID"
                  label="Game Name"
                  options={filteredGameOptions}
                  onChange={handleGameChange}
                  value={
                    filteredGameOptions.find(
                      (option) => option.value === selected.galGameId,
                    ) || null
                  }
                  isClearable={true}
                />
                <p style={{ color: 'grey', fontSize: '.75rem' }}>
                  Note* Please select any of game you want
                </p>
              </div>
              {/* <InputField
                mb="0px"
                name="Date"
                label="Assigned Date"
                type="date"
                onChange={handleDateChange}
              /> */}

              <InputField
  name="From Date"
  label="From Date"
  type="date"
  onChange={(e: any) =>
    setSelected({ ...selected, fromDate: e.target.value })
  }
/>
<InputField
  name="To Date"
  label="To Date"
  type="date"
  onChange={(e: any) =>
    setSelected({ ...selected, toDate: e.target.value })
  }
/>

              <SelectField
                mb="0px"
                id="ctCompanyId"
                name="planId"
                label="Cohorts"
                // options={cohorts}
                options={
                  selected.companyId
                    ? cohortOption.filter(
                        (option: any) =>
                          option.companyId === selected.companyId,
                      )
                    : cohortOption
                }
                onChange={handleCohortChange}
                value={
                  cohortOption.find(
                    (option) => option.value === selected.cohortId,
                  ) || null
                }
                isClearable={true}
              />
            </>
          ) : null}
        </SimpleGrid>
      </Card>

      <Flex
        justifyContent="space-between"
        alignItems="center"
        align="center"
        mb="10px"
        p="20px 0"
        bg={menuBg} // Set background color here to match the box shadow
        boxShadow={shadow} // Apply box shadow to the container
        borderRadius="20px" // Optional: add border radius if needed
        width="100%" // Ensure full width
      >
        <Flex
          alignItems="center"
          flexDirection="row" // Ensure buttons are in a row
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
          p="10px"
        >
          <Flex
            ml={4}
            mt={2}
            position="relative"
            color={textColor}
            fontSize={{ base: '14px', sm: '14px', md: '18px' }}
            fontWeight="500"
            me={{ base: '7px', sm: '7px', md: '12px' }}
            gap="10px"
          >
            {/* <Box position="relative" mx={2}>
              <div
                style={{
                  cursor: 'pointer',
                  transition: '0.5s',
                  color: 'gray.500',
                }}
                onClick={() => handleButtonClick(0)} // Handle button click for Skills
              >
                Skills
              </div>
              {selectedButton === 0 && (
                <Box
                  position="absolute"
                  bottom="-10px"
                  left="50%"
                  transform="translateX(-50%)"
                  width="100%"
                  height="5px"
                  borderRadius="50px"
                  bg="#3311db"
                  transition="width 0.3s ease, opacity 0.3s ease"
                  opacity={selectedButton === 0 ? 1 : 0}
                />
              )}
            </Box> */}

            <Box position="relative" mx={2}>
              <div
                style={{
                  cursor: 'pointer',
                  transition: '0.5s',
                  color: 'gray.500',
                }}
                onClick={() => handleButtonClick(1)} // Handle button click for Approaches
              >
                Approaches
              </div>
              {selectedButton === 1 && (
                <Box
                  position="absolute"
                  bottom="-10px"
                  left="50%"
                  transform="translateX(-50%)"
                  width="100%"
                  height="5px"
                  borderRadius="50px"
                  bg="#3311db"
                  transition="width 0.3s ease, opacity 0.3s ease"
                  opacity={selectedButton === 1 ? 1 : 0}
                />
              )}
            </Box>

            {/* <Box position="relative" mx={2}>
              <div
                style={{
                  cursor: 'pointer',
                  transition: '0.5s',
                  color: 'gray.500',
                }}
                onClick={() => handleButtonClick(2)} // Handle button click for Reflection
              >
                Reflection
              </div>
              {selectedButton === 2 && (
                <Box
                  position="absolute"
                  bottom="-10px"
                  left="50%"
                  transform="translateX(-50%)"
                  width="100%"
                  height="5px"
                  borderRadius="50px"
                  bg="#3311db"
                  transition="width 0.3s ease, opacity 0.3s ease"
                  opacity={selectedButton === 2 ? 1 : 0}
                />
              )}
            </Box> */}

            <Box position="relative" mx={2}>
              <div
                style={{
                  cursor: 'pointer',
                  transition: '0.5s',
                  color: 'gray.500',
                }}
                onClick={() => handleButtonClick(3)} // Handle button click for Feedback
              >
                Feedback
              </div>
              {selectedButton === 3 && (
                <Box
                  position="absolute"
                  bottom="-10px"
                  left="50%"
                  transform="translateX(-50%)"
                  width="100%"
                  height="5px"
                  borderRadius="50px"
                  bg="#3311db"
                  transition="width 0.3s ease, opacity 0.3s ease"
                  opacity={selectedButton === 3 ? 1 : 0}
                />
              )}
            </Box>
     {/* new by kaviy */}
            <Box position="relative" mx={2}>
              <div
                style={{
                  cursor: 'pointer',
                  transition: '0.5s',
                  color: 'gray.500',
                }}
                onClick={() => handleButtonClick(4)}
              >
                Reflection
              </div>
              {selectedButton === 4 && (
                <Box
                  position="absolute"
                  bottom="-10px"
                  left="50%"
                  transform="translateX(-50%)"
                  width="100%"
                  height="5px"
                  borderRadius="50px"
                  bg="#3311db"
                  transition="width 0.3s ease, opacity 0.3s ease"
                  opacity={selectedButton === 4 ? 1 : 0}
                />
              )}
            </Box>
          </Flex>
        </Flex>

        <InputGroup w={{ base: '100%', sm: '100%', md: '200px' }}>
          <InputLeftElement
            children={
              <IconButton
                aria-label="search"
                bg="inherit"
                borderRadius="inherit"
                _active={{
                  bg: 'inherit',
                  transform: 'none',
                  borderColor: 'transparent',
                }}
                _hover={{
                  background: 'none',
                }}
                _focus={{
                  background: 'none',
                  boxShadow: 'none',
                }}
                icon={
                  <SearchIcon
                    color={searchIconColor}
                    w="15px"
                    h="15px"
                    marginTop="20px"
                  />
                }
              />
            }
          />

          <Input
            type="text"
            placeholder="Search..."
              value={searchText}
onChange={(e) => setSearchText(e.target.value)}
            // value={globalFilter || ''}
            // onChange={(e) => setGlobalFilter(e.target.value)}
            bg="#f9f9f9"
            borderRadius="14px"
            w={{ base: '100%', sm: '100%', xl: '300px' }}
            marginRight="20px"
            marginTop="10px"
          />
        </InputGroup>
      </Flex>

      <Box
        ref={tableRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        overflowX="auto"
        overflowY={isHovering ? 'hidden' : 'scroll'} // Disable vertical scroll when inside table
        padding="2px"
        borderRadius={'13px 13px 20px 20px'}
        style={{ marginTop: '-10px' }}
      >
        <Table
          {...getTableProps()}
          variant={'simple'}
          style={{
            border: '2px solid #f7f7f7',
            width: 'max-content', // Ensure the table width accommodates all columns
          }}
        >
          <Thead className="thead" bg={'#f9f9f9'}>
            {selectedButton === 0 ? (
              <Tr>
                <Th colSpan={fixedColumnsCount} className="learnerForAction">
                  {/* Any content for the main header cell */}
                </Th>
                {apiDatacol[0]?.Skills?.map((skill: any, index: any) => (
                  <Th
                    key={index}
                    colSpan={3}
                    className="learnerForAction"
                    textAlign="center"
                    color="black"
                  >
                    <span>{skill.Skill}</span>
                  </Th>
                ))}
              </Tr>
            ) : (
              ''
            )}

            {selectedButton === 1 ? (
  <Tr>
    <Th colSpan={fixedColumnsCount} className="learnerForAction"  borderRight="2px solid #d0d0d0" />
    {(() => {
      // Group approaches by questNo
      const questGroups: { questNo: any; count: number }[] = [];
      (apiDatacol[0]?.Approaches ?? []).forEach((app: any) => {
        const last = questGroups[questGroups.length - 1];
        if (last && last.questNo === app.questNo) {
          last.count++;
        } else {
          questGroups.push({ questNo: app.questNo, count: 1 });
        }
      });
      return questGroups.map((group, index) => (
        <Th
          key={index}
          colSpan={group.count}
          className="learnerForAction"
          textAlign="center"
          color="black"
          borderRight="2px solid #d0d0d0"
        >
          <span>Quest {group.questNo}</span>
        </Th>
      ));
    })()}
  </Tr>
) : ''}

            {selectedButton === 2 ? (
              <Tr>
                <Th colSpan={6} className="learnerForAction">
                  {/* Any content for the main header cell */}
                </Th>
                {apiDatacol[0]?.Reflection?.map((ref: any, index: any) => (
                  <Th
                    key={index}
                    className="learnerForAction"
                    textAlign="center"
                    color="black"
                  >
                    <span>{ref.refKey}</span>
                  </Th>
                ))}
              </Tr>
            ) : (
              ''
            )}
            {/* new by kaviya */}
          {selectedButton === 4 ? (
  <Tr>
    <Th
      colSpan={fixedColumnsCount}
      className="learnerForAction"
      borderRight="2px solid #d0d0d0" 
    />
    {(apiDatacol[0]?.ReflectionAnalytics?.columns ?? []).map(
      (group: any, index: any) => (
        <Th
          key={index}
          colSpan={group.children?.length || 1}
          className="learnerForAction"
          textAlign="center"
          color="black"
          borderRight="2px solid #d0d0d0"  
        >
          <span>{group.header}</span>
        </Th>
      ),
    )}
  </Tr>
) : (
  ''
)}

            {/* {headerGroups.map((headerGroup) => (
              <Tr
                {...headerGroup.getHeaderGroupProps()}
                borderBottom={'2px solid #f7f7f7'}
              >
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    color={'#191919'}
                    textAlign={'start'}
                    p={'10px 10px'}
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? ' 🔽'
                          : ' 🔼'
                        : ''}
                    </span>
                  </Th>
                ))}
              </Tr>
            ))} */}
            {headerGroups.map((headerGroup) => (
  <Tr {...headerGroup.getHeaderGroupProps()} borderBottom={'2px solid #f7f7f7'}>
    {headerGroup.headers.map((column, index) => {
      const isGroupBoundary =
        selectedButton === 4 &&
        (apiDatacol[0]?.ReflectionAnalytics?.columns ?? []).some(
          (g: any) =>
            g.children?.[g.children.length - 1]?.accessor === column.id,
        );
         const isLastFixedCol =
          (selectedButton === 4 || selectedButton === 1) && column.id === 'cohortName';

          const isApproachesGroupBoundary =
  selectedButton === 1 &&
  (() => {
    const approaches = apiDatacol[0]?.Approaches ?? [];
    // find last interaction of each quest
    const lastAccessors: string[] = [];
    let i = 0;
    while (i < approaches.length) {
      let j = i;
      while (j + 1 < approaches.length && approaches[j + 1].questNo === approaches[i].questNo) j++;
      const letter = toColumnLetter(j);
      lastAccessors.push(`TitleAnswered${letter}`);
      i = j + 1;
    }
    return lastAccessors.includes(column.id);
  })();
      return (
        <Th
          {...column.getHeaderProps(column.getSortByToggleProps())}
          color={'#191919'}
          textAlign={'start'}
          p={'10px 10px'}
          borderRight={
            isGroupBoundary || isLastFixedCol|| isApproachesGroupBoundary
              ? '2px solid #d0d0d0'
              : undefined
          }
        >
          {column.render('Header')}
          <span>
            {column.isSorted ? column.isSortedDesc ? ' 🔽' : ' 🔼' : ''}
          </span>
        </Th>
      );
    })}
  </Tr>
))}
          </Thead>

          <Tbody {...getTableBodyProps()} fontSize={'17px'}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} borderBottom={'2px solid #f7f7f7'}>
                  {row.cells.map((cell, index) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        className="learnerForAction"
                        p={'12px'}
                        textAlign={'start'}
                        style={{ backgroundColor: 'white' }}
                    borderRight={
  (selectedButton === 4 &&
    ((apiDatacol[0]?.ReflectionAnalytics?.columns ?? []).some(
      (g: any) => g.children?.[g.children.length - 1]?.accessor === cell.column.id,
    ) || cell.column.id === 'cohortName'))
  ||
  (selectedButton === 1 &&
    (cell.column.id === 'cohortName' ||
      (() => {
        const approaches = apiDatacol[0]?.Approaches ?? [];
        const lastAccessors: string[] = [];
        let i = 0;
        while (i < approaches.length) {
          let j = i;
          while (j + 1 < approaches.length && approaches[j + 1].questNo === approaches[i].questNo) j++;
          lastAccessors.push(`TitleAnswered${toColumnLetter(j)}`);
          i = j + 1;
        }
        return lastAccessors.includes(cell.column.id);
      })()))
    ? '2px solid #d0d0d0'
    : undefined
}             >
                        {selectedButton === 3
                          ? index === 0
                            ? row.original.sNo // ## Show serial number for the first column (index 0)
                            : row.original.Feedback &&
                              row.original.Feedback.length > 0
                            ? row.original.Feedback[0][cell.column.id] ||
                              cell.render('Cell') // ## Dynamically fetch Feedback values; fallback to cell.render
                            : cell.render('Cell')

                            //new by kaviya 
                            : selectedButton === 4
                          ? index === 0
                            ? row.original.sNo
                            : cell.render('Cell') 
                            
        
                            // ## Render cell for all other cases
                          : (selectedButton === 0 ||
                              selectedButton === 1 ||
                              selectedButton === 2) &&
                            selected.galGameId
                          ? index === 0
                            ? row.original.sNo // ## Show serial number for other buttons
                            : cell.render('Cell') // ## Render cell for other buttons
                          : null}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Box>

      <Box
        p={'20px 5px'}
        display={{ base: 'block', xl: 'flex' }}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Box mb={5}>
          <Box mr={'10px'} color={'#000'}>
            <span style={{ color: '#20212396' }}>
              Page{' '}
              <span>
                {/* {pageIndex + 1} of {Math.ceil(data.length / pageSize)} */}
                {pageIndexState + 1} of {totalPages}
              </span>{' '}
            </span>
          </Box>
        </Box>
        <Box display={{ base: 'flex', xl: 'flex' }}>
          <Box mr={'10px'} display={'flex'} alignItems={'center'}>
            <Button
              // onClick={() => previousPage()}
              // disabled={!canPreviousPage}
              onClick={() => handleGoPage(pageIndexState - 1)}
disabled={pageIndexState === 0}
              bg={'#f3f0f0'}
              mr={'5px'}
              h={'40px'}
              w={'40px'}
              borderRadius="50%"
              lineHeight="1em"
              flexShrink={0}
              fontWeight={800}
            >
              {'<'}
            </Button>{' '}
            {getPageNumbers().map((page, index) => (
              <Button
                key={index}
                mr={'5px'}
                h={'40px'}
                w={'40px'}
                borderRadius="100px"
                lineHeight="1em"
                flexShrink={0}
                fontWeight={800}
                // background={pageIndex + 1 === page ? '#3311db' : 'unset'}
                // color={pageIndex + 1 === page ? '#fff' : 'unset'}
                background={pageIndexState + 1 === page ? '#3311db' : 'unset'}
color={pageIndexState + 1 === page ? '#fff' : 'unset'}
                onClick={() =>
                  typeof page === 'number' ? handleGoPage(page - 1) : null
                }
              >
                {page}
              </Button>
            ))}
            <Button
              // onClick={() => nextPage()}
              // disabled={!canNextPage}
              onClick={() => handleGoPage(pageIndexState + 1)}
disabled={pageIndexState + 1 >= totalPages}
              bg={'#f3f0f0'}
              h={'40px'}
              w={'40px'}
              borderRadius="100px"
              lineHeight="1em"
              flexShrink={0}
              fontWeight={800}
            >
              {'>'}
            </Button>{' '}
          </Box>
          <Box></Box>
        </Box>
      </Box>
    </>
  );
};

export default Specific;
